<main data-aos="fade-in">
    <ng-container *ngIf="painting">
        <img src="https://pet-api-vercel.vercel.app/{{painting[0].pImage}}" alt="">
    </ng-container>
</main>